import { httpGet } from '../../../utils/api.utils';
import { actions } from 'react-redux-form';
import Moment from 'moment';
import {convertToTimeZoneDate } from "../../../utils/helpers.utils";

import {
    getAddCostAllocation,
    addCostAllocationDetails,
    deleteCostAllocationDetails,
    circuitCostAllocationFormModel,
    updateCircuitCostAllocationItem,
    getCircuitOrderAddCostAllocation,
    getBillingAccountCostAllocation,
    getTableCircuitGlCodeList,
    getTableCircuitCostCenterList,
    setTableGLCodeLoading,
    setTableCostCenterLoading,
} from '../../../constants/model-reducers/external/inventory/circuit-details/add-cost-allocation.settings';

export const circuitCostAllocationFormInitialState = circuitCostAllocationFormModel;

const defaultState = () => ({
    circuitCostAllocation: {
        datatable: [
            {
                dataItem: [],
                HeaderItem: {} 
            }
        ],
        totalCostCodePercent: 0
    },
    gLCodeListTable: [],
    costCodeListTable: [],
    tableGLCodePage: 1,
    tableCostCodePage: 1,
    hasMoreTableGLCode: true,
    hasMoreTableCostCode: true,
    isTableGLCodeLoading: false,
    isTableCostCenterLoading: false,
    limitRenderGlCode: 1,
    limitRenderCostCode: 1
});

const initialState = defaultState();

export const inventoryCostAllocationActions = {
    getAddCostAllocation: (circuitID) => async (dispatch, state) => {
        var circuitCostAllocation = await httpGet('external/inventory/getAddCostAllocation?circuitId=' + circuitID);

        dispatch({
            type: getAddCostAllocation,
            circuitCostAllocation: circuitCostAllocation
        });
    },

    getCircuitOrderAddCostAllocation: (orderId, requestTypeId, orderCircuitDetailId = 0)  => async (dispatch, state) => {
        var circuitCostAllocation = await httpGet('external/order/getCircuitOrderAddCostAllocation/' + orderId + '/' + requestTypeId + '/' + orderCircuitDetailId);

        dispatch({
            type: getCircuitOrderAddCostAllocation,
            circuitCostAllocation: circuitCostAllocation
        });
    },

    getBillingAccountCostAllocation: (financeId) => async (dispatch, state) => {
        var billingAccountCostAllocation = await httpGet('external/finance/getBillingAccountCostAllocation/' + financeId);
    
        dispatch({
            type: getBillingAccountCostAllocation,
            circuitCostAllocation: billingAccountCostAllocation
        });
    },

    getTableCircuitGlCodeList: (page = 1, searchString = '', limitRender = 1) => async (dispatch, state) => {
        const pageSize = 15;

        dispatch({ type: setTableGLCodeLoading, payload: true });

        var url = `external/autosuggest/GetGLCodesList/${page}/${pageSize}`
        if (searchString) {
            url += `?searchString=${encodeURIComponent(searchString)}`;
        }

        try {
            const res = await httpGet(url);

            if (res != null) {
                dispatch({
                    type: getTableCircuitGlCodeList,
                    payload: {
                        circuitGlCodeList: res,
                        glCodePage: page,
                        limitRenderGlCode: limitRender + 1,
                    }
                });
                return res;
            } else {
                return null
            }
        } catch (err) {
            return null;
        } finally {
            dispatch({
                type: setTableGLCodeLoading,
                payload: false,
                limitRenderGlCode: 1
            });
        }
    },
    getTableCircuitCostCenterList: (page = 1, searchString = '', limitRender = 1) => async (dispatch, state) => {

        const pageSize = 15;

        dispatch({ type: setTableCostCenterLoading, payload: true });

        var url = `external/autosuggest/getCostCodesList/${page}/${pageSize}`
        if (searchString) {
            url += `?searchString=${encodeURIComponent(searchString)}`;
        }

        try {
            const res = await httpGet(url);

            if (res != null) {
                dispatch({
                    type: getTableCircuitCostCenterList,
                    payload: {
                        circuitCostCenterList: res,
                        costCenterPage: page,
                        limitRenderCostCode: limitRender + 1,
                    }
                });

                return res;
            } else {
                return null
            }
        } catch (err) {
            return null;
        } finally {
            dispatch({
                type: setTableCostCenterLoading,
                payload: false,
                limitRenderCostCode: 1,
            });
        }
    },

    addCostAllocationDetails: (data, totalCostCodePercent) => async (dispatch, state) => {
        const { inventoryCircuitCostAllocationForm } = state().form;
        const { datatable } = state().inventoryCostAllocation.circuitCostAllocation;
        var lastModified = data.LastModified;        ;
        const glCodeParam = data.GLCode ? encodeURIComponent(data.GLCode) : "";
        const url = `external/autosuggest/getGLCodeDetailsForCircuitDetails/${sessionStorage.EmployeeID}?val=${glCodeParam}`;
        const circuitGlCodeList = await httpGet(url);
        var circuitCostCenterList = await httpGet('external/autosuggest/getCostCenterDetails/' + sessionStorage.EmployeeID + 
        '?val=' + data.CostCode + '&companycode=' + inventoryCircuitCostAllocationForm.CompanyCode);


        var glCodeName = '';
        var glCodeId = '';
        var glCode = '';
        if (circuitGlCodeList.length > 0) {
            const filteredCircuitGlCodeList = circuitGlCodeList.filter(item => item.GlcodeId === data.GLCodeID)
            glCodeName = filteredCircuitGlCodeList?.[0]?.Name;
            glCodeId = filteredCircuitGlCodeList?.[0]?.GlcodeId;
            glCode = filteredCircuitGlCodeList?.[0]?.Glcode;
        }

        var companyCode = inventoryCircuitCostAllocationForm.CompanyCode;
        var costCodeId = '';
        var costCode = '';
        if (circuitCostCenterList.length > 0) {            
            costCodeId = circuitCostCenterList[0].CostCodeId;
            costCode = circuitCostCenterList[0].CostCenter;
        }

        var dataItem = datatable[0].dataItem
        var HeaderItem = datatable[0].HeaderItem

        var newCostAllocation = [
            ...dataItem,
            {
                ...circuitCostAllocationFormModel,
                CostCodeID: costCodeId,
                CostCode: costCode,
                CompanyCode: companyCode,
                GLCodeID: glCodeId,
                GLCode: glCode,
                GLCodeName: glCodeName,
                CostCodePercent: parseFloat(data.CostCodePercent),
                LastModified: lastModified
            }
        ];

        var newDataTable = [{
            dataItem: newCostAllocation,
            HeaderItem: HeaderItem,
        }];

        dispatch({
            type: addCostAllocationDetails,
            datatable: newDataTable,
            totalCostCodePercent: totalCostCodePercent
        })
    },

    updateCircuitCostAllocationItem: (indexItem) => async (dispatch, state) => {
        const { datatable } = state().inventoryCostAllocation.circuitCostAllocation;
        const { inventoryCircuitCostAllocationForm } = state().form;
        const { activeTimeZoneOffset } = state().adminSetting;

        const glCodeParam = inventoryCircuitCostAllocationForm.GLCode
            ? encodeURIComponent(inventoryCircuitCostAllocationForm.GLCode)
            : "";
        const url = `external/autosuggest/getGLCodeDetailsForCircuitDetails/${sessionStorage.EmployeeID}?val=${glCodeParam}`;
        const circuitGlCodeList = await httpGet(url);
        var circuitCostCenterList = await httpGet('external/autosuggest/getCostCenterDetails/' + sessionStorage.EmployeeID + 
                                                '?val=' + inventoryCircuitCostAllocationForm.CostCode + '&companycode=' + inventoryCircuitCostAllocationForm.CompanyCode);


        var glCodeName = '';
        var glCodeId = '';
        var glCode = '';
        if (circuitGlCodeList.length > 0) {
            glCodeName = circuitGlCodeList[0].Name;
            glCodeId = circuitGlCodeList[0].GlcodeId;
            glCode = circuitGlCodeList[0].Glcode;
        }

        var companyCode = '';
        var costCodeId = '';
        var costCode = '';

        if(inventoryCircuitCostAllocationForm.CompanyCode) {
            companyCode = inventoryCircuitCostAllocationForm.CompanyCode;
        } else {
            companyCode = datatable[0].dataItem[indexItem].CompanyCode
        }

        if (circuitCostCenterList.length > 0) {
            costCodeId = circuitCostCenterList[0].CostCodeId;
            costCode = circuitCostCenterList[0].CostCenter;
        }

        var dataItem = datatable[0].dataItem
        var HeaderItem = datatable[0].HeaderItem

        var lastModified = sessionStorage.FirstName + ' ' + sessionStorage.LastName + ' ' + 'on' + ' '
            + Moment(convertToTimeZoneDate(new Date(), activeTimeZoneOffset?.UtcOffset)).format('L').toString() + ' '
            + Moment(convertToTimeZoneDate(new Date(), activeTimeZoneOffset?.UtcOffset)).format('LT');

        dataItem[indexItem] = {
            ...inventoryCircuitCostAllocationForm,
            CostAllocationID: dataItem[indexItem].CostAllocationID,
            CostCodePercent: parseFloat(inventoryCircuitCostAllocationForm.CostCodePercent),
            GLCodeName: glCodeName,
            GLCodeID: glCodeId,
            GLCode: glCode,
            CostCodeID: costCodeId,
            CompanyCode: companyCode,
            CostCode: costCode,
            LastModified: lastModified,
        };

        var totalCostCodePercent = 0;
        totalCostCodePercent = dataItem.reduce(
            (total, item) => total + parseFloat(item.CostCodePercent),
            0
        );

        var newDataTable = [{
            dataItem: dataItem,
            HeaderItem: HeaderItem,
        }];

        dispatch({
            type: updateCircuitCostAllocationItem,
            datatable: newDataTable,
            totalCostCodePercent: totalCostCodePercent
        });
    },

    deleteCostAllocationDetails: (index) => (dispatch, state) => {
        const { datatable } = state().inventoryCostAllocation.circuitCostAllocation;

        var dataItem = datatable[0].dataItem
        var HeaderItem = datatable[0].HeaderItem

        var newDataItem = [...dataItem]
        newDataItem.splice(index, 1)
        var newCostAllocationList = newDataItem


        var totalCostCodePercent = 0;
        totalCostCodePercent = newDataItem.reduce(
            (total, item) => total + parseFloat(item.CostCodePercent),
            0
        );


        var newDataTable = [{
            dataItem: newCostAllocationList,
            HeaderItem: HeaderItem,
        }]

        dispatch({
            type: deleteCostAllocationDetails,
            datatable: newDataTable,
            totalCostCodePercent: totalCostCodePercent
        });
    },
}
    
    

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getTableCircuitGlCodeList:
            const { circuitGlCodeList, glCodePage, limitRenderGlCode } = action.payload;
            return {
                ...state,
                gLCodeListTable: glCodePage === 1
                    ? circuitGlCodeList
                    : [...state.gLCodeListTable, ...circuitGlCodeList],
                hasMoreTableGLCode: circuitGlCodeList.length > 0,
                tableGLCodePage: glCodePage,
                limitRenderGlCode: limitRenderGlCode
            };

        case getTableCircuitCostCenterList:
            const { circuitCostCenterList, costCenterPage, limitRenderCostCode } = action.payload;
            return {
                ...state,
                costCodeListTable: costCenterPage === 1
                    ? circuitCostCenterList
                    : [...state.costCodeListTable, ...circuitCostCenterList],
                hasMoreTableCostCode: circuitCostCenterList.length > 0,
                tableCostCodePage: costCenterPage,
                limitRenderCostCode: limitRenderCostCode
            };
        case setTableGLCodeLoading:
            return {
                ...state,
                isTableGLCodeLoading: action.payload,
                limitRenderGlCode: action.limitRenderGlCode
            };
        case setTableCostCenterLoading:
            return {
                ...state,
                isTableCostCenterLoading: action.payload,
                limitRenderCostCode: action.limitRenderCostCode
            };
        case getAddCostAllocation:
            return {
                ...state,
                circuitCostAllocation: action.circuitCostAllocation,
            };
        case getCircuitOrderAddCostAllocation:
            return {
                ...state,
                circuitCostAllocation: action.circuitCostAllocation,
            };
        case getBillingAccountCostAllocation:
            return {
                ...state,
                circuitCostAllocation: action.circuitCostAllocation,
            };
        case addCostAllocationDetails:
            return {
                ...state,
                circuitCostAllocation: {
                    ...state.circuitCostAllocation,
                    datatable: action.datatable,
                    totalCostCodePercent: action.totalCostCodePercent
                },
            };
        case deleteCostAllocationDetails:
            return {
                ...state,
                circuitCostAllocation: {
                    ...state.circuitCostAllocation,
                    datatable: action.datatable,
                    totalCostCodePercent: action.totalCostCodePercent
                },
            };
        case updateCircuitCostAllocationItem:
            return {
                ...state,
                circuitCostAllocation: {
                    ...state.circuitCostAllocation,
                    datatable: action.datatable,
                    totalCostCodePercent: action.totalCostCodePercent
                }
            };
 
        default:
        return state;
    }

};